const getTranslation = (id, trans, def= false) => {
    const { currentLang, strings, debug } = trans
    let transString = ''

    if(strings && strings.hasOwnProperty(id) && strings[id].hasOwnProperty(currentLang)) {
        transString = strings[id][currentLang]
    } else {
        transString = def ? def : ''

        if(debug) {
            console.warn(`No translation for id ${id}`)
        }
    }

    return transString
}

export default getTranslation